module.exports = __webpack_public_path__ + "img/telegram.24d831f7.svg";